module.exports = __webpack_public_path__ + "static/media/delibsApp.92a8195f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/delibsApp.png
// module id = 426
// module chunks = 9